import React from 'react';
import { FormattedMessage } from 'react-intl/dist';
import { StyledSelect, YearSelectorProps, ConditionalRendering } from '../../utils';

const YearSelector: React.FC<YearSelectorProps> = ({ years = [], currentYear, onYearChange }) => {
    return (
        <span>
            <label htmlFor="application_year">
                <FormattedMessage id="cap.applications.header.applicationYear" />
            </label>

            <ConditionalRendering isTrue={years.length === 0}>
                <span> {currentYear}</span>
            </ConditionalRendering>

            <ConditionalRendering isTrue={years.length > 0}>
                <StyledSelect id="application_year" value={currentYear} onChange={onYearChange}>
                    {years?.map((year, index) => (
                        <option key={index} value={year}>
                            {year}
                        </option>
                    ))}
                </StyledSelect>
            </ConditionalRendering>
        </span>
    );
};
export default YearSelector;
